<script>
import { mapActions } from 'pinia';

import { useUserStore } from '../../../store/useUserStore.js';
import { newMembersProfile, followNewUser } from '../api/new-members';
import { startChat } from '../api/chat';

export default {
    name: 'CpNewMembers',
    components: {
        CpBox: require('../box').default,
        CpBoxContent: require('../box-content').default,
        CpGrid: require('../grid').default,
        CpGridItem: require('../grid-item').default,
        CpButton: require('../button').default,
        CpPageContent: require('../page-content.vue').default,
        CpImage: require('../image.vue').default,
        CpIcon: require('../icon').default,
        CpButtonLink: require('../button-link').default,
        CpTagIcon: require('../tags/icon').default,
        NewMemberAddBlogIcon: require('../social-feed/icons/new-member-add-blog').default,
        ChatIcon: require('../social-feed/icons/chat').default,
        VueSimpleSpinner: require('../vue-simple-spinner').default,
        CpBaseSvgIcon: require('../base-svg-icon').default,
        CpChatButton: require('../components/ChatButton').default,
    },
    props: {
        user: Object,
        currentUser: Object,
    },
    data() {
        return {
            newMembers: [],
            loadingNewMembers: true,
            indexClickedNewUser: undefined,
            loadingChatIndex: undefined,
        }
    },
    mounted() {
        newMembersProfile(this.user.id)
            .then((response) => {
                this.newMembers = response.new_members;
                this.loadingNewMembers = false;
            })
            .catch((error) => {
                this.loadingNewMembers = false;
                console.warn(error);
            });
    },
    methods: {
        profile(slug) {
            return '/profile/' + slug;
        },
        followNewUser(user_id, index) {
            if (!this.authUser) {
                window.location.href = '/user/login';
            } else {
                this.indexClickedNewUser = index;
                followNewUser(user_id).then((response) => {
                    this.indexClickedNewUser = undefined;
                    this.loadingNewMembers = true;
                    newMembersProfile(this.user.id)
                        .then(async (response) => {
                            this.newMembers = response.new_members;
                            this.loadingNewMembers = false;
                            await this.handleChatEnabled(user_id);
                        })
                        .catch((error) => {
                            this.loadingNewMembers = false;
                            console.warn(error);
                        });
                });
            }
        },
        handleStartChat(newMember, index) {
            this.loadingChatIndex = index;
            if (!this.authUser) {
                window.location.href = '/user/login';
            } else {
                startChat(this.loadingChatIndex, newMember, this.user);
            }
        },
        ...mapActions(useUserStore, ['handleChatEnabled']),
    },
    computed: {
        authUser() {
            return this.$root.authUser;
        },
    }
};
</script>

<template>
    <div style="overflow: hidden;">
        <cp-page-content>
            <h2 v-if="(!user.relationships.tags.length && !authUser) || (!user.relationships.tags.length && authUser && !currentUser.tags.length)" class="title-members-related">CrowdBlue New Members</h2>
            <h2 v-else class="title-members-related">CrowdBlue Members Supporting Similar Issues</h2>

            <div v-if="loadingNewMembers" class="heading-4" style="text-align: center; margin-bottom: 20px;">
                <vue-simple-spinner />Loading...
            </div>

            <cp-grid v-else-if="!loadingNewMembers && newMembers.length" stretch-content style="margin-bottom: 30px;">
                <cp-grid-item
                    :span="($root.isMobile && !$root.isTablet) || ($root.isMobile && $root.isTablet) ? 12 : 2.4"
                    v-for="(newMember, index) in newMembers"
                    :key="newMember.id"
                    style="display: block;"
                >
                    <div style="border: 1px solid #ddd;">
                        <a :href="newMember.permalink" style="text-decoration: none; color: black;">
                            <div :class="{ 'box-member': newMember.tags.length }">
                                <div style="text-align: center; margin-bottom: 10px; margin-top: 10px;" class="social-feed-post-profile-wrapper" >
                                    <cp-image :src="newMember.image" alt="" width="100%" circular></cp-image>
                                </div>
                                <div v-if="newMember.tags.length">
                                    <cp-grid stretch-content>
                                        <cp-grid-item v-for="(item, indexTag) in newMember.tags" :key="item.name" :span="12" class="blog-tag-mobile">
                                            <cp-button :tag="true" class="blog-tag font-blog-tag-related">
                                              <cp-tag-icon :tag="item.name" />
                                            </cp-button>
                                        </cp-grid-item>
                                    </cp-grid stretch-content>
                                </div>
                            </div>
                            <div>
                                <h3 class="name-new-member-related margin-mobile">{{ newMember.first_name }}</h3>
                                <h3 class="name-new-member-related" style="margin-bottom: 10px">{{ newMember.last_name }}</h3>
                            </div>
                        </a>
                        <div class="buttons-new-members">
                            <vue-simple-spinner v-if="indexClickedNewUser === index" :size="24" class="loading"/>
                            <a v-else class="btn-new-member" @click="followNewUser(newMember.id, index)">
                                <cp-base-svg-icon
                                    :width="30"
                                    :height="30"
                                    :viewBox="'0 0 20 19'"
                                    :icon-color="'none'"
                                    :stroke-color="'none'"
                                >
                                    <new-member-add-blog-icon/>
                                </cp-base-svg-icon>
                            </a>
                            <vue-simple-spinner v-if="loadingChatIndex === index" :size="24" class="loading"/>
                            <CpChatButton v-else :otherUserId="newMember.id" :callback="() => handleStartChat(newMember, index)" :loading="loadingChatIndex" />
                        </div>
                    </div>
                </cp-grid-item>
            </cp-grid>
        </cp-page-content>
    </div>
</template>
<style>
.blog-tag-mobile {
    margin-top: 0;
    margin-bottom: 0;
}
.box-member {
    min-height: 380px;
}
.title-members-related {
    font-size: 30px;
    text-align: center;
    margin: 50px 0 20px;
}
.loading {
    margin: 0 5px;
}
.btn-new-member {
    margin: 0 5px 0;
    cursor: pointer;
}
.buttons-new-members {
    display: flex;
    justify-content: center;
    align-items: center;
}
.name-new-member-related {
    text-align: center;
    margin: 0;
    word-break: break-all;
}
.blog-tag {
    background: none;
    border: none;
    font-size: 16px;
    cursor: auto!important;

}
.font-blog-tag-related {
    font-size: 14px;
    cursor: pointer!important;
}
.title-1 {
    text-align: center;
    margin: 20px 0px 0px 0px;
}
.heading-2 {
    text-align: left;
    font-size: 18px;
    color: #121212;
    line-height: 1.5;
    font-family: "proxima-nova", Gotham, Helvetica, sans-serif;
    font-weight: 400;
}
@media only screen and (min-width: 1024px) and (max-width: 1366px) {
    .box-member {
        min-height: 390px;
    }
}
@media only screen and (min-width: 768px) and (max-width: 1023px) {
    .font-blog-tag-related {
        font-size: 12px;
    }
    .title-members-related {
        font-size: 26px;
    }
    .box-member {
        min-height: 0;
    }
    .margin-mobile {
        margin-top: 10px;
    }
}
@media only screen and (max-width: 767px) {
    .title-members-related {
        font-size: 22px;
    }
    .box-member {
        min-height: 0;
    }
    .margin-mobile {
        margin-top: 10px;
    }
}
</style>
